var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_1616)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.723 13.8051H33.0105C33.0124 6.18095 26.7386 0 18.9999 0C11.2612 0 4.98745 6.18095 4.98745 13.8051H4.27495C1.91325 13.8051 -0.00195312 15.692 -0.00195312 18.0187C-0.00195312 20.3455 1.91325 22.2323 4.27495 22.2323H4.98745C4.98745 22.2323 7.02615 34.2049 18.3957 35.9551C18.7947 36.0168 19.2032 36.0168 19.6022 35.9551C30.9737 34.2049 33.0105 22.2323 33.0105 22.2323H33.723C36.0847 22.2323 37.9999 20.3455 37.9999 18.0187C37.9999 15.692 36.0847 13.8051 33.723 13.8051Z",
    fill: "#4F46E5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.75
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7231 13.8051H33.0106C33.0106 12.9235 32.9232 12.0624 32.7636 11.2275C31.0935 21.9628 23.465 30.7625 13.3057 34.2498C14.7497 35.0472 16.4331 35.6537 18.3958 35.9551C18.7948 36.0168 19.2033 36.0168 19.6023 35.9551C30.9738 34.2049 33.0106 22.2323 33.0106 22.2323H33.7231C36.0848 22.2323 38 20.3455 38 18.0187C38 15.692 36.0848 13.8051 33.7231 13.8051Z",
    fill: "#050505"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2521 0.649542C21.9107 0.228369 20.4838 0 18.9999 0C11.2612 0 4.98745 6.18095 4.98745 13.8051H4.27495C1.91325 13.8051 -0.00195312 15.692 -0.00195312 18.0187C-0.00195312 20.3455 1.91325 22.2323 4.27495 22.2323H4.98745C4.98745 22.2323 5.16795 23.2881 5.71705 24.8174C15.3823 20.6281 22.3306 11.484 23.2521 0.649542Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6707 25.5214C22.4655 25.6001 22.2907 25.7423 22.1805 25.9295L19.3286 30.7964C19.1823 31.0454 18.8175 31.0454 18.6712 30.7964L15.8193 25.9295C15.7091 25.7423 15.5343 25.6001 15.3291 25.5214C11.4246 24.0127 8.70954 20.1697 8.95844 15.7334C9.23204 10.8665 13.6514 6.58737 18.5952 6.39644C24.3332 6.17556 29.0547 10.6924 29.0547 16.2968C29.0547 20.4917 26.408 24.0763 22.6707 25.5214Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2098 15.7349C24.2098 16.2497 23.7861 16.6671 23.2636 16.6671C22.7411 16.6671 22.3174 16.2497 22.3174 15.7349C22.3174 15.2202 22.7411 14.8027 23.2636 14.8027C23.7861 14.8027 24.2098 15.2202 24.2098 15.7349Z",
    fill: "#4F46E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 16.6671C19.5225 16.6671 19.9461 16.2498 19.9461 15.7349C19.9461 15.2201 19.5225 14.8027 18.9999 14.8027C18.4773 14.8027 18.0537 15.2201 18.0537 15.7349C18.0537 16.2498 18.4773 16.6671 18.9999 16.6671Z",
    fill: "#4F46E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7364 16.6671C15.2589 16.6671 15.6826 16.2498 15.6826 15.7349C15.6826 15.2201 15.2589 14.8027 14.7364 14.8027C14.2138 14.8027 13.7902 15.2201 13.7902 15.7349C13.7902 16.2498 14.2138 16.6671 14.7364 16.6671Z",
    fill: "#4F46E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_1616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameSmall);
export default __webpack_public_path__ + "static/media/Frame_small.6c5826fb6e083f136dd7eccc685b3ae3.svg";
export { ForwardRef as ReactComponent };